import React, { useState } from 'react';
import { BaseFormModalTemplate, FormModalButtons } from './BaseModalTemplate';
import { Alert } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { NetworkRequestStatus } from 'constants/literals';
import { toast } from 'react-toastify';
import { ApiDataBinding } from 'react-api-data';
import { getClientErrors } from 'utils/apiUtils';

interface Props {
    header: string;
    description: string;
    isOpen: boolean;
    toggle: () => void;
    onSubmit: () => Promise<ApiDataBinding<any>>;
    successMessage: string;
}

function DeleteModal(props: Props) {
    const { t } = useTranslation();
    const [isSubmitting, setIsSubmitting] = useState(false);

    async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        setIsSubmitting(true);
        const binding = await props.onSubmit();
        setIsSubmitting(false);
        if (binding.request.networkStatus === NetworkRequestStatus.Success) {
            handleSuccess(binding);
        } else if (binding.request.networkStatus === NetworkRequestStatus.Failed) {
            handleFailure(binding);
        }
    }

    function handleSuccess(_binding: ApiDataBinding<any>) {
        toast.success(props.successMessage);
        props.toggle();
    }

    function handleFailure(binding: ApiDataBinding<any>) {
        const errors = getClientErrors(binding.request);
        if (errors) {
            toast.error(errors);
        }
    }

    return (
        <BaseFormModalTemplate
            isOpen={props.isOpen}
            toggle={isSubmitting ? undefined : props.toggle}
            handleSubmit={handleSubmit}
            header={props.header}
            body={
                <Alert color="warning" className="mb-0">
                    <strong>{t('common.warning')}</strong>
                    <p>{props.description}</p>
                </Alert>
            }
            footer={<FormModalButtons loading={isSubmitting} toggle={props.toggle} />}
        />
    );
}

export default DeleteModal;
